import Vue from 'vue'
import VueRouter from 'vue-router'
import ICS from "vue-ics";
import store from './store'
import VueGtag from "vue-gtag";
import vuetify from './vuetify'
import application from './application.vue'
import Clipboard from 'v-clipboard'
import VueAppend from 'vue-append'
import VueNativeSock from "vue-native-websocket";
import VueCookies from 'vue-cookies';
import VueCompositionAPI from "@vue/composition-api";
import VueYoutube, { getIdFromUrl } from 'vue-youtube';
import vueVimeoPlayer from 'vue-vimeo-player';

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Clipboard)
Vue.use(VueAppend)
Vue.use(ICS);
Vue.use(VueCookies);
Vue.use(VueCompositionAPI);
Vue.use(VueYoutube);
Vue.use(vueVimeoPlayer);

import axios from 'axios'

import index from './components/index'
import pageNotFound from './components/404'
import navigation from './components/navigation'

import administratorLogin from './components/administrator/login'
import administratorForgotPassword from './components/administrator/forgotPassword'
import administratorResetPassword from './components/administrator/resetPassword'
import administratorNavigation from './components/administrator/navigation'
import administratorTenant from './components/administrator/tenant'
import administratorTenantStaff from './components/administrator/tenantStaff'
import administratorTenantPlan from './components/administrator/tenantPlan'
import administratorAdministratorEmail from './components/administrator/administratorEmail'
import administratorRoomLibrary from './components/administrator/roomLibrary'
import administratorButtonLibrary from './components/administrator/buttonLibrary'
import administratorBoothBackgroundLibrary from './components/administrator/boothBackgroundLibrary'
import administratorBoothDesignLibrary from './components/administrator/boothDesignLibrary'
import administratorLeaderboardLibrary from './components/administrator/leaderboardLibrary'
import administratorFrameLibrary from './components/administrator/frameLibrary'
import administratorTransitionLibrary from './components/administrator/transitionLibrary'
import administratorTrainingAndTutorial from './components/administrator/trainingAndTutorial'
import administratorEmailTemplate from './components/administrator/emailTemplate'
import administratorGlobalCalendar from './components/administrator/globalCalendar'

import tenantLogin from './components/tenant/login'
import tenantForgotPassword from './components/tenant/forgotPassword'
import tenantResetPassword from './components/tenant/resetPassword'
import tenantNavigation from './components/tenant/navigation'
import tenantDashboard from './components/tenant/dashboard'
import tenantDashboardMain from './components/tenant/dashboardMain'
import tenantChat from './components/tenant/chat/newChat'
import tenantPublicLog from './components/tenant/chat/log/publicLog'
import tenantPrivateLog from './components/tenant/chat/log/privateLog'
import tenantExperience from './components/tenant/experience'
import tenantStructure from './components/tenant/structure'
import tenantLeaderboard from './components/tenant/leaderboard'
import tenantExperienceReport from './components/tenant/report/experienceReport'
import tenantStaff from './components/tenant/staff'
import tenantTraining from './components/tenant/training'
import tenantUser from './components/tenant/user'
import tenantBusinessName from './components/tenant/businessName'
import tenantTicket from './components/tenant/ticket'
import tenantBooth from './components/tenant/booth'
import tenantPoster from './components/tenant/poster'
import tenantTrack from './components/tenant/track'
import tenantPresentation from './components/tenant/presentation'
import tenantScheduleTrack from './components/tenant/scheduletrack'
import tenantProfile from './components/tenant/profile'
import tenantChangePassword from './components/tenant/changePassword'
import tenantEmailTemplate from './components/tenant/emailTemplate'
import tenantUploadedFileTemplate from './components/tenant/uploadedFile'
import tenantCustomColors from './components/tenant/customColors'
import tenantTrainingAndTutorialTemplate from './components/tenant/trainingAndTutorial'
import setupWizard from './components/tenant/setupWizard'
import boothSetup from './components/tenant/boothSetup'
import posterSetup from './components/tenant/posterSetup'
import notification from './components/tenant/notification'
import zoomSettings from './components/tenant/zoomSettings'
import tenantInterests from './components/tenant/interests'
import tenantAnalytics from './components/tenant/analytics'

import experienceNavigation from './components/experience/navigation'
import experienceLogin from './components/experience/login'
import experienceRegister from './components/experience/register'
import experienceForgotPassword from './components/experience/forgotPassword'
import experienceResetPassword from './components/experience/resetPassword'
import experienceStructure from './components/experience/structure'
import experienceBooth from './components/experience/booth'
import experienceLeaderboard from './components/experience/leaderboard'
import experienceChat from './components/experience/chat'
import experienceProfile from './components/experience/profile'
import experienceMeeting from './components/experience/meeting'
import experienceChangePassword from './components/experience/changePassword'
import experienceAuditorium from './components/experience/auditorium'
import experienceAuditoriumOfftrack from './components/experience/offtrack'
import experiencePresentation from './components/experience/presentation'
import experiencePassThrough from './components/experience/passThrough'
import experienceIndex from './components/experience/index'
import experienceMatchAndFind from './components/experience/matchAndFind'
import appointmentAnswer from './components/experience/appointmentAnswer'

import clinicRoom from './components/clinic/room'
import tenantView from './components/clinic/tenantView'

import oauthLogin from './components/oauth/login'

let routes = [
	{ path: '/', name: 'index', component: index, props: true },
	{ path: '/404', component: pageNotFound, props: true },
	{ path: '*', redirect: '/404' },

	// administrator portal
	{
		path: '', component: navigation, props: true, children: [
			{ path: '/administrator', component: administratorLogin, props: true },
			{ path: '/administrator/forgotpassword', component: administratorForgotPassword, props: true },
			{ path: '/administrator/resetpassword/:token', component: administratorResetPassword, props: true }
		]
	},
	{
		path: '', component: administratorNavigation, props: true,
		children: [
			{
				path: '/administrator/tenant', component: administratorTenant, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/tenant/:tenantId/staff', component: administratorTenantStaff, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/plan/tenant', component: administratorTenantPlan, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/administratorEmail', component: administratorAdministratorEmail, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/room/library', component: administratorRoomLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/booth/background/library', component: administratorBoothBackgroundLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/booth/design/library', component: administratorBoothDesignLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/leaderboard/library', component: administratorLeaderboardLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/frame/library', component: administratorFrameLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/transition/library', component: administratorTransitionLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/button/library', component: administratorButtonLibrary, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/emailtemplate', component: administratorEmailTemplate, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/globalCalendar', component: administratorGlobalCalendar, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
			{
				path: '/administrator/TrainingAndTutorial', component: administratorTrainingAndTutorial, props: true,
				meta: {
					requiresAuth: true,
					role: "Administrator",
				},
			},
		]
	},

	// oauth
	{
		path: '', component: navigation, props: true, children: [
			{ path: '/authorize', component: oauthLogin, props: true },
		]
	},

	// tenant portal
	// booth setup
	// poster setup
	{
		path: '/appointment/answer/:answerType/:meetingId/:attendeeId', component: appointmentAnswer, props: true,
	},
	{
		path: '/poster/setup/:experienceId/:tenantId/:posterSetupId', component: posterSetup, props: true,
	},
	{
		path: '/booth/setup/:experienceId/:tenantId/:tenantPlanId/:boothSetupId', component: boothSetup, props: true,
	},
	{
		path: '', component: navigation, props: true, children: [
			{ path: '/tenant', component: tenantLogin, props: true },
			{ path: '/tenant/forgotpassword', component: tenantForgotPassword, props: true },
			{ path: '/tenant/resetpassword/:token', component: tenantResetPassword, props: true },
			{ path: '/tenant/createpassword/:token', component: tenantResetPassword, props: true }
		]
	},
	{
		path: '', component: tenantNavigation, props: true,
		children: [
			{
				path: '/tenant/experience/:experienceId/bookRequest', component: tenantView, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/staff', component: tenantStaff, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/training', component: tenantTraining, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Training",
					type: "All"
				},
			},
			{
				path: '/tenant/dashboard', component: tenantDashboardMain, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/experience', component: tenantExperience, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/experience/add/:mode', component: tenantExperience, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/trainingAndTutorial', component: tenantTrainingAndTutorialTemplate, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/zoomSettings', component: zoomSettings, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/analytics', component: tenantAnalytics, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/zoomSettings/authorize', component: zoomSettings, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/experience/clinic', component: setupWizard, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/experience/:experienceId/dashboard', component: tenantDashboard, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/user', component: tenantUser, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/businessName', component: tenantBusinessName, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/ticket', component: tenantTicket, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/structure', component: tenantStructure, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/experience/:experienceId/booth', component: tenantBooth, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/poster', component: tenantPoster, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/chat/list', component: tenantChat, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/chat/log/group', component: tenantPublicLog, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/chat/log/user', component: tenantPrivateLog, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/report/experienceReport', component: tenantExperienceReport, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/leaderboard', component: tenantLeaderboard, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/track', component: tenantTrack, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/presentation', component: tenantPresentation, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/schedule', component: tenantScheduleTrack, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "Exhibition"
				},
			},
			{
				path: '/tenant/experience/:experienceId/notification', component: notification, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/experience/:experienceId/emailtemplate', component: tenantEmailTemplate, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/experience/:experienceId/uploadedFile', component: tenantUploadedFileTemplate, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/experience/:experienceId/customColors', component: tenantCustomColors, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/experience/:experienceId/interests', component: tenantInterests, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				}
			},
			{
				path: '/tenant/:tenantSlug/profile', component: tenantProfile, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
			{
				path: '/tenant/:tenantSlug/changepassword', component: tenantChangePassword, props: true,
				meta: {
					requiresAuth: true,
					role: "Tenant_Staff",
					type: "All"
				},
			},
		]
	},

	// experience portal
	{
		path: '', component: navigation, props: true,
		children: [
			{ path: '/:tenantSlug/:experienceSlug', component: experienceIndex, props: true },
			{ path: '/:tenantSlug/:experienceSlug/login', component: experienceLogin, props: true },
			{ path: '/:tenantSlug/:experienceSlug/register', component: experienceRegister, props: true },
			{ path: '/:tenantSlug/:experienceSlug/forgotpassword', component: experienceForgotPassword, props: true },
			{ path: '/:tenantSlug/:experienceSlug/resetpassword/:token', component: experienceResetPassword, props: true }
		]
	},
	{
		path: '', component: experienceNavigation, props: true,
		children: [
			{
				path: '/:tenantSlug/:experienceSlug/hall/:structureSlug', component: experienceStructure, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/booth/:boothId', component: experienceBooth, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/chat', component: experienceChat, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/leaderboard', component: experienceLeaderboard, props: true,
				meta: {
					requiresAuth: true,
				}
			},
			{
				path: '/:tenantSlug/:experienceSlug/auditorium/offtrack', component: experienceAuditoriumOfftrack, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/auditorium/:auditoriumId', component: experienceAuditorium, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/auditorium/:auditoriumId/track/:trackId', component: experienceAuditorium, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/networking', component: experienceMatchAndFind, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/presentation/:trackId/:presentationScheduleId/:presentationId/', component: experiencePresentation, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/presentation/:trackId/:presentationScheduleId/:presentationId/:linkToType', component: experiencePresentation, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/meeting/:meetingId', component: experienceMeeting, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/profile', component: experienceProfile, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/changepassword', component: experienceChangePassword, props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/:tenantSlug/:experienceSlug/passthrough/:type/:direction/:id', component: experiencePassThrough, props: true,
				meta: {
					requiresAuth: true,
				}
			},
			{
				path: '/:tenantSlug/:experienceSlug/passthrough/:type/:direction/:trackId/:presentationScheduleId/:presentationId', component: experiencePassThrough, props: true,
				meta: {
					requiresAuth: true,
				}
			}
		]
	},

	// clinic
	{
		path: '/:tenantSlug/:experienceSlug/room/:structureSlug?', component: clinicRoom, props: true
	},
]

let mode = '';

// Estrogen IQ
if (store.state.domainThatUseAliases.includes(window.location.hostname.toLowerCase())) {
	routes = [
		{ path: '/404', component: pageNotFound, props: true },
		{ path: '*', redirect: '/404' },

		{path: '/:tenantSlug/:experienceSlug/room/:structureSlug?', component: clinicRoom, props: true},
		{path: '/estrogeniq/estrogeniq/room/estrogeniq',  component: clinicRoom, props: true, alias: '/'},
		{path: '/estrogeniq/estrogeniq/room/intro',  component: clinicRoom, props: true, alias: '/intro'},
		{path: '/estrogeniq/estrogeniq/room/e4illuminated',  component: clinicRoom, props: true, alias: '/e4illuminated'},
		{path: '/estrogeniq/estrogeniq/room/aboutbirthcontrol',  component: clinicRoom, props: true, alias: '/aboutbirthcontrol'},
		{path: '/estrogeniq/estrogeniq/room/estrogen101',  component: clinicRoom, props: true, alias: '/estrogen101'},
		{path: '/estrogeniq/estrogeniq/room/theestrogenexhibit2',  component: clinicRoom, props: true, alias: '/theestrogenexhibit2'},
	]
	mode = 'history';
}

const router = new VueRouter({
	mode: mode,
    routes: routes
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth && record.meta.role === "Administrator")) {
		if (store.getters.isLoggedIn && store.state.principal.role === "Administrator") {
			next();
			return;
		}
		next('/administrator');
	} if (to.matched.some(record => record.meta.requiresAuth && record.meta.role === "Tenant_Staff")) {
		if (to.matched.some(record => (record.meta.type === store.state.principal.type || record.meta.type === 'All'))) {
			if (store.getters.isLoggedIn && store.state.principal.role === "Tenant_Staff") {
				next();
				return;
			}
		}
		next('/tenant');
	} if (to.matched.some(record => record.meta.requiresAuth && !record.meta.role)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/' + to.params.tenantSlug + '/' + to.params.experienceSlug);
	} else {
		next();
	}
})

/* eslint-disable */
Vue.prototype.$http = axios;
Vue.prototype.$vchaturl = "https://v-chat.v-unite.com";
Vue.prototype.$vtrainingurl = "https://php.v-unite.com/apps/v-unite-training-v1";
Vue.prototype.$medspaurl = "https://www.medspabizuniversity.com";

axios.defaults.baseURL = '';

if (window.location.origin.includes("localhost")) {
	axios.defaults.withCredentials = true;
	axios.defaults.baseURL = 'http://localhost:8900/v-unite';
	store.state.webSocket.host = "ws://localhost:8900/v-unite";
} else {
	store.state.webSocket.host = window.location.origin.replace("https://", "wss://");
}

var analyticsId = ['G-F8YNPFNNNK', "G-Z8PL46QF9Y"];
if (window.location.origin.includes("experience.v-unite.com")) {
	analyticsId = ['G-XQR6MSGH6C', "G-61LYDMC573"];
}

Vue.use(VueGtag, {
	config: { id: analyticsId[1] },
	includes: [
		{id: analyticsId[0]}
	]
	})

Vue.prototype.$window = window;

export const eventBus = new Vue();

new Vue({
	router,
	store,
	vuetify,
	render: display => display(application),
	data() {
		return {
			selectedExperience: {},
			loader: { count: 0, stroke: 7, diameter: 50, value: false },
			videos: [
				{
					reg: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
					url: 'https://www.youtube.com/embed/$5?autoplay=',
				},
				{
					reg: /^(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?(\/[a-zA-Z0-9]*)?(\\?h=[a-zA-Z0-9]*)?.*/i,
					url: 'https://player.vimeo.com/video/$5?h=$6&autoplay=',
				},
			],
			showLiveSupport: false,
			isFitToWidth: false,
			experienceId: null
		};
	},
	created: function () {
		axios.interceptors.request.use(
			request => {
				if(request.method == 'post'){
					request.headers['Csrf-Token'] = this.$cookies.get("Csrf-Token");
				}

				this.load();
				return request;
			},
			error => {
				this.unload();

				let notification = { title: 'Unknown error', content: "" };
				if (error.response) {
					if (error.response.status == 400) {
						notification.title = 'Bad request';
					} else if (error.response.status == 500) {
						notification.title = 'Server error';
					} else if (error.response.status == 401) {
						notification.title = 'Unauthorized';
					} else if (error.response.status == 403) {
						notification.title = 'Forbidden';
					} else if (error.response.status == 404) {
						notification.title = 'Not found';
					} else {
						notification.title = 'Notification (' + error.response.status + ')';
					}
					notification.content = error.response.data;
				}
				store.commit("showNotification", notification);

				return Promise.reject(error);
			}
		);

		axios.interceptors.response.use(
			response => {
				this.unload();
				return response;
			},
			error => {

				this.unload();

				let notification = { title: 'Unknown error', content: "" };
				if (error.response) {
					if (error.response.status == 400) {
						notification.title = 'Bad request';
					} else if (error.response.status == 500) {
						notification.title = 'Server error';
					} else if (error.response.status == 401) {
						notification.title = 'Unauthorized';
					} else if (error.response.status == 403) {
						notification.title = 'Forbidden';
					} else if (error.response.status == 404) {
						notification.title = 'Not found';
					} else {
						notification.title = 'Notification (' + error.response.status + ')';
					}
					notification.content = error.response.data;
				}

				if (this.experienceId == 1362227) {
					if (notification.content == 'Your login will activate 30 minutes before the event (6:30am PT 10/4)') {
						notification.title = "The Event Hasn't Started Yet"
					}
				}
				store.commit("showNotification", notification);

				return Promise.reject(error);
			}
		);
	},
	methods: {
		load() {
			this.loader.count++;
			this.loader.value = true;
		},
		unload() {
			this.loader.count--;
			if (this.loader.count < 0) {
				this.loader.count = 0;
			}
			this.loader.value = this.loader.count > 0;
		},
		ellipsify(text, limit) {
			if (text && text.length > limit) {
				return text.substring(0, limit) + '...';
			}
			return text;
		},
		logSuccess: function (o) {
		},
		logError: function (o) {
		},
		clone(object) {
			return JSON.parse(JSON.stringify(object));
		},
		avatar(name) {
			return axios.defaults.baseURL + '/asset/file/user/' + name + '.png?avatar=default';
		},
		textify(text, before, after) {
			if (text && text.trim().length > 0) {
				return (before ? before : '') + text + (after ? after : '');
			}
			return text;
		},
		isImage(text) {
			if (text) {
				let q = text.toLowerCase();
				return q.endsWith('.jpg') || q.endsWith('.jpeg') || q.endsWith('.png');
			}
			return false;
		},
		isVideo(text) {
			if (text) {
				let q = text.toLowerCase();
				return q.endsWith('.mp4');
			}
			return false;
		},
		isYoutubeUrl(text) {
			if (text) {
				if (text.includes("youtube")) {
					return true;
				}
			}
			return false;
		},
		isVimeoUrl(text) {
			if (text) {
				if (text.includes("vimeo")) {
					return true;
				}
			}
			return false;
		},
		getVideoTypeByUrl(url) {
			if (this.isYoutubeUrl(url)) {
				return "youtube";
			} else if (this.isVimeoUrl(url)) {
				return "vimeo";
			}
			return "mp4";
		},
		getYoutubeId(url, params){
			let id = getIdFromUrl(url);
			if (params) {
				params.playlist = id;
			}

			return id;
		},
		getYoutubeParams(url) {
			let params = { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''}
			let id = getIdFromUrl(url);
			if (params) {
				params.playlist = id;
			}
			return params;
		},
		playYoutube(refs) {
			if (refs) {
				for (let i = 0; i < refs.length; i++) {
					if (refs[i].player) {
						refs[i].player.playVideo();
					}
				}
			}
		},
		asset(text) {
			if (text) {
				if (text.toLowerCase().startsWith('http')) {
					return text;
				} else {
					return axios.defaults.baseURL + '/asset/file/' + text;
				}
			}
			return null;
		},
		saveActivityLog(entity) {
			entity.experienceUserId = store.state.principal.id;
			axios
				.post("/system/activitylog/save", {
					entity: entity,
				})
				.then(() => { })
				.catch(() => { });
		},
		parseVideoUrl(src, isAutoplay = true, isSound = false) {
			if (src) {
				for (let i = 0; i < this.videos.length; i++) {
					const v = this.videos[i];
					var m = v.reg.exec(src);
					if (m) {
						if (m[7]) {
							// handle case https://vimeo.com/<id>?h=<guid> (7)
							let guid = m[7].replace("h=", "");
							src = v.url.replace("$5", m[5]).replace("$6", guid);
						} else if (m[6]) {
							// handle case https://vimeo.com/<id>/<guid> (6)
							let guid = m[6].replace("/", "");
							src = v.url.replace("$5", m[5]).replace("$6", guid);
						} else {
							src = src.replace(v.reg, v.url);
						}
						src += !isAutoplay ? '0' : '1';
						if (src.includes("vimeo.com")) {
							src += !isSound ? '&muted=1' : '&muted=0';
						} else {
							src += !isSound ? '&mute=1' : '&mute=0';
						}
						return src;
					}
				}
			}
		},
		randomNumber() {
			return Date.now();
		},
		initLiveSupport() {
			return "\u003cscript type\u003d'text/javascript'\u003e!function(e,t,n){function a(){var e\u003dt.getElementsByTagName('script')[0],n\u003dt.createElement('script');n.type\u003d'text/javascript',n.async\u003d!0,n.src\u003d'https://beacon-v2.helpscout.net',e.parentNode.insertBefore(n,e)}if(e.Beacon\u003dn\u003dfunction(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue\u003d[],'complete'\u003d\u003d\u003dt.readyState)return a();e.attachEvent?e.attachEvent('onload',a):e.addEventListener('load',a,!1)}(window,document,window.Beacon||function(){});\r\n\u003c/script\u003e\u003cstyle\u003e\u003c/style\u003e";
		},
		dialogLiveSupport(tenant, experience) {
			if (!this.showLiveSupport) {
				Beacon('init', '7456ba41-2d3f-4db8-b007-cbd80bb0aa8d');
				Beacon('identify', {
					name: store.state.principal.firstName + " " + store.state.principal.lastName,
					email: store.state.principal.email,
					avatar: store.state.principal.image ? (axios.defaults.baseURL + '/asset/file/user/' + store.state.principal.image) : "",
					'experience': experience,
					'tenant': tenant
				  });
				Beacon('open');
				this.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
				this.showLiveSupport = true;
			} else {
				Beacon('destroy');
				this.showLiveSupport = false;
			}
		},
		setCurrentUrlLiveSupport(currentUrl){
			Beacon('event', {
				type: 'page-viewed',
				url: window.location.origin + '/#' + currentUrl,
				title: window.location.origin + '/#' + currentUrl,
				});
		},
		smallAsset(src) {
			if (src) {
				if (src.toLowerCase().startsWith('http') && src.toLowerCase().includes('amazonaws.com')) {
					return src.replace("amazonaws.com/", "amazonaws.com/small/");
				}
			}
		},
		largeAsset(src) {
			if (src) {
				if (src.toLowerCase().startsWith('http') && src.toLowerCase().includes('amazonaws.com')) {
					return src.replace("amazonaws.com/", "amazonaws.com/large/");
				}
			}
		},
		isImageExist: function(src, status) {
			if (this.isImage(src)) {
				var image = new Image();
				image.onload = function() {
					if (this.width > 0) {
						status(true);
					}
				}
				image.onerror = function() {
					status(false);
				}
				image.src = src;
			}
		},
		reverseToOriginal(src) {
			if (src) {
				if (src.toLowerCase().startsWith('http') && src.toLowerCase().includes('amazonaws.com/small/')) {
					return src.replace("amazonaws.com/small/", "amazonaws.com/");
				} else if (src.toLowerCase().startsWith('http') && src.toLowerCase().includes('amazonaws.com/large/')) {
					return src.replace("amazonaws.com/large/", "amazonaws.com/");
				}
				return src;
			}
		},
		appendMuteVideo(videoUrl) {
			let append = "";

			if(videoUrl.includes("youtu") && videoUrl.match("http(?:s)?:\\/\\/(?:m.)?(?:www\\.)?youtu(?:\\.be\\/|be\\.com\\/(?:watch\\?(?:feature=youtu.be\\&)?v=|v\\/|embed\\/|user\\/(?:[\\w#]+\\/)+))([^&#?\\n]+)")){
				append += "mute=1";
			} else if (videoUrl.includes("vimeo") && videoUrl.match("(https?:\\/\\/)?(www.)?(player.)?vimeo.com\\/([a-z]*\\/)*([0-9]{6,11})[?]?.*")){
				append += "muted=1";
			}

			if(append != "" && videoUrl.includes("?")) {
				append = "&" + append;
			} else if(append != "") {
				append = "?" + append;
			}
			return videoUrl + append;
		},
		isEmbedVideo(videoUrl){
			if (videoUrl) {
				return videoUrl.match("^(http|https)://") && (videoUrl.includes("youtu") || videoUrl.includes("vimeo"));
			} else {
			return false;
			}
		},
		setBackgroundSize(type){
			if(type === "Cover"){
				return "cover";
			} if(type === "Contain"){
				return "contain";
			} else {
				return "fill";
			}
		},
		setBackgroundPosition(linkTo){
			let result = "";
			if(linkTo.subType === "Cover"){
				if(linkTo.subPosX != null){
					result += linkTo.subPosX.toLowerCase();
				} else {
					result += "center";
				}

				result += " ";

				if(linkTo.subPosY != null){
					result += linkTo.subPosY.toLowerCase();
				} else {
					result += "center";
				}
			} else {
				return "center center"
			}
			return result;
		},
		getUrlTeamsWithLink(link) {
			let baselocation = axios.defaults.baseURL.includes("localhost") ? "http://localhost:3000/" : (axios.defaults.baseURL + "teams/");
			let parameter = link.startsWith("https://teams.microsoft.com") ? "teamsLink" : "groupId";
			return baselocation + "?" + parameter + "=" + link;
		},
		getFileNameFromUrl(url){
			var words = url.split("/");
			let fileName = words[words.length - 1];
				if(fileName.includes("\\")){
					words = fileName.split("\\");
					fileName = words[words.length - 1];
				}
			return fileName;
		},
		executeFileDownload(linkTo){
			let url = this.asset(linkTo.value);

			if(linkTo.subType == "Current_Tab"){
				window.location = url;
			} else if (linkTo.subType == "New_Tab"){
				window.open(url, "_blank");
			} else if (linkTo.subType == "Dialog"){
				this.dialogFileDownload.fileName = this.getFileNameFromUrl(url);
				this.dialogFileDownload.link = url;
				this.dialogFileDownload.show = true;
			} else if (linkTo.subType == "Force_Download") {
				location.href = url + "?download";
			}
		},
		convertLinkTypeLabel(linkType){
			if(linkType === "Structure"){
				return "Room";
			} else if(linkType === "Book_Consultation"){
				return "Contact Form";
			} else {
				return linkType.replaceAll("_", " ");
			}
		},
		connectToWebSocket(url){
			Vue.use(VueNativeSock, this.$store.state.webSocket.host + url , { store: this.$store, format: "json" });
		},
		closeWebSocketDialog() {
			store.commit('closeWebSocketNotification');
		},
		initTinyMceFromVueEditor(height){
			let result = this.initTinyMceEditor();
			// match same height and styling format from Vue 2 Editor
			result.height = height;
			result.content_style = "p { margin: 0; }";
			return result;
		},
		initTinyMceEditor() {
			// Make toolbar layout similar to Vue 2 Editor
			return {
				height: 300,
				menubar: false,
				plugins: ["textcolor", "code", "link", "image", "lists", "media", "paste"],
				paste_as_text: true,
				image_title: true,
				automatic_uploads: true,
				file_picker_types: "image",
				file_picker_callback: function (cb, value, meta) {
					var input = document.createElement("input");
					input.setAttribute("type", "file");
					input.setAttribute("accept", "image/*");

					input.onchange = function () {
					  var file = this.files[0];

					  var reader = new FileReader();
					  reader.onload = function () {
						var id = "blobid" + (new Date()).getTime();
						var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
						var base64 = reader.result.split(",")[1];
						var blobInfo = blobCache.create(id, file, base64);
						blobCache.add(blobInfo);

						cb(blobInfo.blobUri(), { title: file.name });
					  };
					  reader.readAsDataURL(file);
					};

					input.click();
				  },
				toolbar_mode: "wrap",
				toolbar: "formatselect | bold italic underline strikethrough | \
					alignleft aligncenter alignright alignjustify| blockquote code | \
					bullist numlist | outdent indent | forecolor backcolor | link image media | removeformat | pastetext | help"
				}
		},
		appendTinyMCECustomFonts(initTextEditor) {
			// css Taken from Application.vue, make sure fonts collection are same
			initTextEditor.content_style =
			`@import url('https://fonts.googleapis.com/css2?family=Allerta&family=Comic+Neue&family=Inter&family=Noto+Sans+Symbols&family=Oswald:wght@700&family=Roboto&display=swap');

				@font-face {
			  	font-family: "greek";
			  	src: local("greek"), url("/fonts/greek.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "xingy dings";
			  	src: local("xingy_dings"), url("/fonts/xingy_dings.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "fredoka one";
			  	src: local("fredoka_one"), url("/fonts/fredoka_one.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "abril fatface";
			  	src: local("AbrilFatface-Regular"), url("/fonts/AbrilFatface-Regular.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "sacramento";
			  	src: local("Sacramento-Regular"), url("/fonts/Sacramento-Regular.ttf") format("truetype");
				}

				@font-face {
			  	font-family: "dm sans";
			  	src: local("DMSans-Regular"), url("/fonts/DMSans-Regular.ttf") format("truetype");
				}

				@font-face{
					font-family:"helvetica-neue-67-medium-condensed";
					src: local("Helvetica_Neue_67_Medium_Condensed"), url("/fonts/Helvetica_Neue_67_Medium_Condensed.ttf") format("truetype");
				}`;

			initTextEditor.font_formats = "Abril Fatface=abril fatface;" +
				"Andale Mono=andale mono,times;" +
				"Arial=arial,helvetica,sans-serif;" +
				"Arial Black=arial black,avant garde;" +
				"Book Antiqua=book antiqua,palatino;" +
				"Comic Neue=comic neue;" + //"Comic Sans MS=comic sans ms,sans-serif;"+
				"Courier New=courier new,courier;" +
				"DM Sans=dm sans;" +
				"Georgia=georgia,palatino;" +
				"Inter=inter;" + //"Helvetica=helvetica;"+
				"Helvetica Neue 67 Medium Condensed=helvetica-neue-67-medium-condensed;" +
				"Oswald=oswald;" + //"Impact=impact,chicago;"+
				"Greek=greek;" + //"Symbol=symbol;"+
				"Sacramento=sacramento;" +
				"Tahoma=tahoma,arial,helvetica,sans-serif;" +
				"Terminal=terminal,monaco;" +
				"Times New Roman=times new roman,times;" +
				"Allerta=allerta;" + //"Trebuchet MS=trebuchet ms,geneva;"+
				"Verdana=verdana,geneva;" +
				"Fredoka One=fredoka one;" + //"Webdings=webdings;"+
				"Xingy Dings=xingy dings;" //"Wingdings=wingdings,zapf dingbats"
			;
		}
	}
}).$mount('#application')
